import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './workspace.scss';

function ListToolbar({ actions, activeFilters, children, className, filters, search, settings, ...rest }) {
  return (
    <div className={classnames('list-toolbar list-toolbar--responsive', className)} {...rest}>
      <div className="list-toolbar__primary">
        {search && <div className="list-toolbar__search">{search}</div>}
        {filters && <div className="list-toolbar__filters">{filters}</div>}
        {children}
      </div>
      {(settings || actions) && (
        <div className="list-toolbar__secondary">
          {settings && <div className="list-toolbar__settings">{settings}</div>}
          {actions && <div className="list-toolbar__actions">{actions}</div>}
        </div>
      )}
      {activeFilters && <div className="list-toolbar__active-filters">{activeFilters}</div>}
    </div>
  );
}

ListToolbar.defaultProps = {
  actions: null,
  activeFilters: null,
  children: null,
  className: '',
  filters: null,
  search: null,
  settings: null
};

ListToolbar.propTypes = {
  actions: PropTypes.node,
  activeFilters: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  filters: PropTypes.node,
  search: PropTypes.node,
  settings: PropTypes.node
};

export { ListToolbar };
